const APP_KEY = process.env.VUE_APP_APP_KEY || ''

import { getStorage } from './local-storage';

export function authHeader() {
  // return authorization header with jwt token
  let admin = getStorage('_admin')

  if (admin && admin._token) {
    return {
        headers: {
        'Access-Controll-Allow-Origin': '*',
        'app_key': APP_KEY,
        'Authorization': `Bearer ${admin._token}`
      }
    };
  } else {
    return {};
  }
}